import React from 'react'
import { bool, func, number, string, oneOfType } from 'prop-types'
import styled from 'styled-components'

const StyledSVG = styled.svg`
  fill: ${({ fillColor }) => fillColor};
  stroke: ${({ strokeColor }) => strokeColor};
`

export function CaretLeft({ ariaHidden, stroke, fill, focusable, height, title, width, ...rest }) {
  const h = height || '1rem'
  const w = width || '1rem'

  return (
    <StyledSVG
      viewBox='0 0 32 32'
      width={w}
      height={h}
      aria-hidden={ariaHidden}
      focusable={focusable}
      fillColor={fill}
      strokeColor={stroke}
      strokeWidth='2'
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path
        d='M19.7325 23.222L12 15.4895 19.4895 8'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </StyledSVG>
  )
}

CaretLeft.defaultProps = {
  ariaHidden: false,
  focusable: false,
  stroke: '#000',
  fill: '#000',
}

CaretLeft.propTypes = {
  ariaHidden: bool,
  stroke: oneOfType([string, func]),
  fill: oneOfType([string, func]),
  focusable: bool,
  height: number,
  title: string,
  width: number,
}
